export default class IconsGrid {
  init() {
    const iconsGridElements = Array.from(
      document.querySelectorAll('.icons-grid')
    );

    for (let iconsGridElement of iconsGridElements) {
      const button = iconsGridElement.querySelector(
        '.icons-grid__load-more-button'
      );
      const buttonLess = iconsGridElement.querySelector(
        '.icons-grid__load-less-button'
      );

      const computedStyles = getComputedStyle(iconsGridElement);

      const gridConfig = {
        columns: {
          mobile:
            parseInt(
              computedStyles.getPropertyValue('--grid-column-count-mobile')
            ) || 2,
          tablet:
            parseInt(
              computedStyles.getPropertyValue('--grid-column-count-tablet')
            ) || 3,
          laptop:
            parseInt(
              computedStyles.getPropertyValue('--grid-column-count-laptop')
            ) || 4,
          desktop:
            parseInt(
              computedStyles.getPropertyValue('--grid-column-count-desktop')
            ) || 5,
        },
        rows: {
          mobile:
            parseInt(
              computedStyles.getPropertyValue('--grid-row-count-mobile')
            ) || 3,
          tablet:
            parseInt(
              computedStyles.getPropertyValue('--grid-row-count-tablet')
            ) || 3,
          laptop:
            parseInt(
              computedStyles.getPropertyValue('--grid-row-count-laptop')
            ) || 4,
          desktop:
            parseInt(
              computedStyles.getPropertyValue('--grid-row-count-desktop')
            ) || 4,
        },
      };

      const items = Array.from(
        iconsGridElement.querySelectorAll('.icons-grid__item')
      );

      const initialItemCount = this.getItemCountForViewport(gridConfig);

      if (!this.paginateItems(items, initialItemCount)) {
        button.classList.add('icons-grid__load-more-button--hidden');
        button.setAttribute('disabled', 'true');
      }

      button.addEventListener(
        'click',
        () => {
          let itemCount = this.getItemCountForViewport(gridConfig);

          const currentPage = parseInt(
            getComputedStyle(iconsGridElement).getPropertyValue('--page')
          );

          if (!this.paginateItems(items, itemCount, currentPage + 1)) {
            button.classList.add('icons-grid__load-more-button--hidden');
          }

          buttonLess.classList.remove('icons-grid__load-less-button--hidden');

          iconsGridElement.style.setProperty('--page', currentPage + 1);

          this.scrollToElement(iconsGridElement);
        },
        window.supportPassive
      );

      if (buttonLess) {
        buttonLess.addEventListener(
          'click',
          () => {
            let itemCount = this.getItemCountForViewport(gridConfig);

            const currentPage = parseInt(
              getComputedStyle(iconsGridElement).getPropertyValue('--page')
            );

            const startIndex = itemCount * (currentPage - 1);

            for (let i = startIndex; i < startIndex + itemCount; i++) {
              if (items[i]) {
                items[i].classList.remove('icons-grid__item--visible');
              }
            }

            if (currentPage <= 2) {
              buttonLess.classList.add('icons-grid__load-less-button--hidden');
              button.classList.remove('icons-grid__load-more-button--hidden');
            }

            if (currentPage > 1) {
              iconsGridElement.style.setProperty('--page', currentPage - 1);
              button.classList.remove('icons-grid__load-more-button--hidden');
            }

            this.scrollToElement(iconsGridElement);
          },
          window.supportPassive
        );
      }
    }
  }

  scrollToElement(element) {
    let elementBottomPosition =
      element.getBoundingClientRect().bottom + window.pageYOffset;
    let offsetPosition = elementBottomPosition - window.innerHeight + 50;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
  }

  paginateItems(items, itemsPerPage, page = 1) {
    for (
      let i = itemsPerPage * page - itemsPerPage;
      i < itemsPerPage * page;
      i++
    ) {
      if (items[i]) {
        items[i].classList.add('icons-grid__item--visible');
      } else {
        return false;
      }
    }

    return items.length > itemsPerPage * page;
  }

  getItemCountForViewport(gridConfig) {
    let itemCount = gridConfig.columns.mobile * gridConfig.rows.mobile;

    if (window.matchMedia('(min-width: 1200px)').matches) {
      itemCount = gridConfig.columns.desktop * gridConfig.rows.desktop;
    } else if (window.matchMedia('(min-width: 1024px)').matches) {
      itemCount = gridConfig.columns.laptop * gridConfig.rows.laptop;
    } else if (window.matchMedia('(min-width: 768px)').matches) {
      itemCount = gridConfig.columns.tablet * gridConfig.rows.tablet;
    }

    return itemCount;
  }
}
